/* eslint-disable react/no-array-index-key */
import { Box, Group } from '@mantine/core';
import { Link } from 'react-router-dom';

import SearchBar from '@/components/layout/nav/topbar/searchbar';
import DropdownMenu from './DropdownMenu';
import Logout from '@/features/auth/components/Logout';
import ClientTopbarActions from './ClientTopbarActions';

import type { LayoutProps } from '../../types';

import UserIcon from '@/assets/icons/content/user.svg';
import classes from './Topbar.module.css';

type TopBarProps = {
  topbarItems: LayoutProps['topbarItems'];
  includeSearch?: LayoutProps['includeSearch'];
  useClientTopbarActions?: LayoutProps['useClientTopbarActions'];
  scrolled: boolean;
};

const TopBar = ({ topbarItems, includeSearch, useClientTopbarActions, scrolled }: TopBarProps) => (
  <div className={`${classes.barWrapper} ${!includeSearch ? classes.noSearch : ''}`}>
    {includeSearch && <SearchBar />}

    <Group
      component="ul"
      gap={10}
      classNames={{ root: `${classes.barNavList} ${scrolled ? classes.scrolled : ''}` }}
    >
      {useClientTopbarActions ? (
        <Box component="li" visibleFrom="sm" key="client-topbar-actions">
          <ClientTopbarActions />
        </Box>
      ) : (
        <>
          {topbarItems &&
            topbarItems.length > 0 &&
            topbarItems.map(({ item, mobileHidden }, i) => (
              <Box
                component="li"
                visibleFrom={mobileHidden ? 'sm' : undefined}
                key={`topbaritem-${i}`}
              >
                {item}
              </Box>
            ))}
          <li>
            <DropdownMenu icon={<UserIcon />}>
              <li className={classes.menuItem}>
                <Link to="settings">Settings</Link>
              </li>
              <li className={classes.menuItem}>
                <Logout />
              </li>
            </DropdownMenu>
          </li>
        </>
      )}
    </Group>
  </div>
);

export default TopBar;
